import React, { useState, useEffect, useLayoutEffect, useMemo, useRef } from "react"
import { createPortal } from "react-dom"
import { useRecoilState } from "recoil"
import axios from 'axios';
import { selectedInventoryItemsState, countSelectedInventoryItemState, selectedProfileState, showImportStockIdModalState, currentSelectedIdState, currentSelectedInventoryItemsState, selectedInventoryIdState, templateTypeState, templateProfileConfigDataState, paginationLinkListState, currentCheckIdState } from "../recoilStateSelector/PrintPreviewState";
import { pageStatusState, pageHeadingBreadCrumbState } from "../recoilStateSelector/profilePageState.js";
import { template3 } from "components/common/barcodeTemplate/template3";
import { _Api } from "../../api/_call"
import Select from "react-select";
import { Document, Page, pdfjs } from "react-pdf";
import { FiGitBranch, FiPrinter, FiRefreshCw, FiZoomIn, FiZoomOut } from "react-icons/fi";
import { inventoryQueryClient } from "components/inventory/InventorySelectToPrintout";

import '../printoutStyle.scss'
import { exportPdf, logBarcodePrint } from "./PrintLayout";
import { getPrintConfig, attachCustomPriceCodes } from "components/common/helpers/barcodeHelper";
import { expandItemsByQuantityForSelection, getPrintItemKey } from "../../../components/common/barcodeTemplate/printQuantity";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// When enabled, preview all selected items until a checkbox is selected, then preview checked items only.
const PREVIEW_FILTER_BY_CHECKED_ITEMS = true;
const CHECKED_PREVIEW_TEMPLATES = new Set(["template_1", "template_2"]);
const EACH_QTY_TEMPLATES = new Set(["template_1", "template_2", "template_3"]);
const LIMIT_TEMPLATE12_PREVIEW = true;
const TEMPLATE12_PREVIEW_LIMIT = 10;
const PREVIEW_ZOOM_MIN = 50;
const PREVIEW_ZOOM_MAX = 450;
const PREVIEW_ZOOM_FACTOR = 1.25;

const PrintPreview = () => {

  const iframeRef = useRef(false)

  let [, setPageStatus] = useRecoilState(pageStatusState)
  let [, setPageHeadingBreadCrumb] = useRecoilState(pageHeadingBreadCrumbState)
  let [selectedProfile, setSelectedProfileState] = useRecoilState(selectedProfileState)
  let [paginationLinkList, setPaginationLinkList] = useRecoilState(paginationLinkListState)
  const [templateType, setTemplateType] = useRecoilState(templateTypeState)
  const [startSearch, setStartSearch] = useState(false)
  const [pdfUri, setPdfUri] = useState(false)
  const [previewZoom, setPreviewZoom] = useState(100)
  const [previewPageCount, setPreviewPageCount] = useState(0)
  const [resultSearchList, setResultSearchList] = useState(false)
  const [layoutProfileId, setLayoutProfileId] = useState(false)
  const [selectedInventoryItems, setSelectedInventoryItems] = useRecoilState(selectedInventoryItemsState)
  const [countSelectedInventoryItem, setCountSelectedInventoryItem] = useRecoilState(countSelectedInventoryItemState)
  const [checkedItem, setCheckedItem] = useState([]);
  const [eachQtyItemIds, setEachQtyItemIds] = useState([]);
  const [eachAll, setEachAll] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);
  const [disabledItemSearch, setDisabledItemSearch] = useState(true);
  const searchDebounceRef = useRef(null);
  const inventorySearchInputRef = useRef(null);
  const inventorySearchRequestRef = useRef(0);
  const previewRequestRef = useRef(0);
  const lastPreviewSignatureRef = useRef(null);
  const checkedPreviewInitializedRef = useRef(false);
  const checkedPreviewModeRef = useRef(false);
  const selectedPreviewItemIdsRef = useRef(new Set());
  const appliedProfileIdRef = useRef(null);
  const printInProgressRef = useRef(false);
  const previewViewerRef = useRef(null);
  const previewPanRef = useRef(null);
  const searchWrapRef = useRef(null);
  const [searchMenuBox, setSearchMenuBox] = useState(null);
  // Scoped to this mount only: a fresh visit to this page gets a fresh Map/null,
  // so a profile edited elsewhere is always picked up next time the page opens.
  // Within one visit, repeated preview/print runs for the same profile reuse
  // the same request instead of refetching getByid/get-db-info every time.
  const templateProfileCacheRef = useRef(new Map());
  const storeInfoRequestRef = useRef(null);
  const getCachedTemplateProfile = (id) => {
    const cache = templateProfileCacheRef.current;
    if (!cache.has(id)) {
      const request = _Api({ _id: id }, "api/v1/template-printout/getByid").catch((error) => {
        cache.delete(id); // don't let a failed lookup poison the cache
        throw error;
      });
      cache.set(id, request);
    }
    return cache.get(id);
  };
  const getCachedStoreInfo = () => {
    if (!storeInfoRequestRef.current) {
      storeInfoRequestRef.current = _Api({}, "api/v1/store-info/get-db-info").catch((error) => {
        storeInfoRequestRef.current = null;
        throw error;
      });
    }
    return storeInfoRequestRef.current;
  };

  const [showImportStockIdModal, setShowImportStockIdModal] = useRecoilState(showImportStockIdModalState)
  const [currentSelectedId, setCurrentSelectedId] = useRecoilState(currentSelectedIdState)
  const [, setCurrentSelectedInventoryItems] = useRecoilState(currentSelectedInventoryItemsState)
  const [, setSelectedInventoryId] = useRecoilState(selectedInventoryIdState)
  const [, setCurrentCheckId] = useRecoilState(currentCheckIdState)
  const [templateProfileList, setTemplateProfileList] = useState(false);
  const [templateProfileConfigData, setTemplateProfileConfigData] = useRecoilState(templateProfileConfigDataState);
  const checkedItemIds = useMemo(
    () => Array.isArray(checkedItem) ? checkedItem : [],
    [checkedItem]
  );
  const template3PrintItems = templateType === "template_3"
    ? selectedInventoryItems.filter(item => checkedItemIds.includes(String(item.id)))
    : selectedInventoryItems;
  const isEachQtyTemplate = EACH_QTY_TEMPLATES.has(templateType);
  const isCheckedPreviewMode = PREVIEW_FILTER_BY_CHECKED_ITEMS && CHECKED_PREVIEW_TEMPLATES.has(templateType);
  const shouldFilterPreviewByCheckedItems = isCheckedPreviewMode && checkedPreviewInitializedRef.current;
  const checkedPreviewItems = useMemo(
    () => selectedInventoryItems.filter(item => checkedItemIds.includes(String(item.id))),
    [checkedItemIds, selectedInventoryItems]
  );
  const previewItems = shouldFilterPreviewByCheckedItems ? checkedPreviewItems : selectedInventoryItems;
  const printItems = templateType === "template_3" ? template3PrintItems : previewItems;
  const quantitySourceItems = templateType === "template_3" ? template3PrintItems : previewItems;
  const eachQtyItems = useMemo(() => {
    if (!isEachQtyTemplate) {
      return quantitySourceItems;
    }

    return expandItemsByQuantityForSelection(quantitySourceItems, eachQtyItemIds);
  }, [eachQtyItemIds, isEachQtyTemplate, quantitySourceItems]);
  const previewItemsForDisplay = useMemo(() => {
    if (!LIMIT_TEMPLATE12_PREVIEW || !CHECKED_PREVIEW_TEMPLATES.has(templateType)) {
      return previewItems;
    }

    return eachQtyItems.slice(0, TEMPLATE12_PREVIEW_LIMIT);
  }, [eachQtyItems, previewItems, templateType]);
  const canPrint = printItems.length > 0;
  const printItemCount = isEachQtyTemplate
    ? eachQtyItems.length
    : printItems.length;
  const previewScale = previewZoom / 100;
  const zoomPreviewBy = (direction) => {
    setPreviewZoom((currentZoom) => {
      const nextZoom = direction > 0
        ? currentZoom * PREVIEW_ZOOM_FACTOR
        : currentZoom / PREVIEW_ZOOM_FACTOR;

      return Math.min(
        PREVIEW_ZOOM_MAX,
        Math.max(PREVIEW_ZOOM_MIN, Math.round(nextZoom / 5) * 5)
      );
    });
  };
  const zoomPreviewIn = () => {
    zoomPreviewBy(1);
  };
  const zoomPreviewOut = () => {
    zoomPreviewBy(-1);
  };
  const resetPreviewZoom = () => {
    setPreviewZoom(100);
  };
  useEffect(() => {
    setPreviewPageCount(0);
    previewPanRef.current = null;
    if (previewViewerRef.current) {
      previewViewerRef.current.scrollTo(0, 0);
    }
  }, [pdfUri]);
  useEffect(() => {
    previewPanRef.current = null;
    if (previewViewerRef.current) {
      previewViewerRef.current.scrollTo(0, 0);
    }
  }, [previewZoom]);
  useEffect(() => {
    const viewer = previewViewerRef.current;
    if (!viewer) {
      return undefined;
    }

    const handleWheelZoom = (event) => {
      if (!event.ctrlKey) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      zoomPreviewBy(event.deltaY < 0 ? 1 : -1);
    };

    viewer.addEventListener("wheel", handleWheelZoom, { passive: false });
    return () => viewer.removeEventListener("wheel", handleWheelZoom);
  }, [pdfUri]);
  const startPreviewPan = (event) => {
    if (event.button !== 0 || !previewViewerRef.current) {
      return;
    }

    const viewer = previewViewerRef.current;
    previewPanRef.current = {
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      scrollLeft: viewer.scrollLeft,
      scrollTop: viewer.scrollTop
    };
    event.currentTarget.setPointerCapture(event.pointerId);
    event.currentTarget.classList.add("is-dragging");
  };
  const movePreviewPan = (event) => {
    const pan = previewPanRef.current;
    const viewer = previewViewerRef.current;
    if (!pan || !viewer || pan.pointerId !== event.pointerId) {
      return;
    }

    viewer.scrollLeft = pan.scrollLeft - (event.clientX - pan.startX);
    viewer.scrollTop = pan.scrollTop - (event.clientY - pan.startY);
  };
  const endPreviewPan = (event) => {
    const pan = previewPanRef.current;
    if (!pan || pan.pointerId !== event.pointerId) {
      return;
    }

    if (event.currentTarget.hasPointerCapture(event.pointerId)) {
      event.currentTarget.releasePointerCapture(event.pointerId);
    }
    event.currentTarget.classList.remove("is-dragging");
    previewPanRef.current = null;
  };
  const checkSelectedItem = (e) => {
    const itemId = String(e.target.value);
    if (e.target.checked) {
      setCheckedItem((prev) => prev.includes(itemId) ? prev : [...prev, itemId])
    } else {
      setCheckedItem((prev) => prev.filter(id => id !== itemId))
    }
  }
  const checkAllSelectedItem = (e) => {
    if (e.target.checked) {
      let newCheck = [];
      selectedInventoryItems.map((v, k) => {
        return newCheck.push(String(v.id))

      })
      setCheckedItem(newCheck)
    } else {
      setCheckedItem([])
    }
  }
  const toggleEachQtyItem = (item) => {
    const itemKey = getPrintItemKey(item);
    setEachQtyItemIds((prev) => {
      if (prev.includes(itemKey)) {
        setEachAll(false);
        return prev.filter((key) => key !== itemKey);
      }

      const next = [...prev, itemKey];
      if (selectedInventoryItems.length > 0
        && selectedInventoryItems.every((selectedItem) => next.includes(getPrintItemKey(selectedItem)))) {
        setEachAll(true);
      }
      return next;
    });
  }
  const toggleEachAll = (e) => {
    const enabled = e.target.checked;
    setEachAll(enabled);
    setEachQtyItemIds(enabled ? selectedInventoryItems.map(getPrintItemKey) : []);
  }
  const deleteListSelection = (removeList) => {
    const getItemId = (item) => String(item?.id ?? item?._id ?? "");
    const removeIds = new Set((removeList || []).map(id => String(id)));
    const removedStockIds = selectedInventoryItems
      .filter(v => removeIds.has(getItemId(v)))
      .map(v => v.stock_id)
    const currentList = selectedInventoryItems.filter(v => !removeIds.has(getItemId(v)))
    const remainingIds = currentList.map((item) => getItemId(item)).filter(Boolean)
    setSelectedInventoryItems(currentList)
    setCountSelectedInventoryItem(currentList.length)
    setCheckedItem(remainingIds)
    selectedPreviewItemIdsRef.current = new Set(remainingIds)
    checkedPreviewInitializedRef.current = remainingIds.length > 0
    setCurrentSelectedInventoryItems(prev => (prev || []).filter(v => !removeIds.has(getItemId(v))))
    setCurrentSelectedId(prev => (prev || []).filter(id => !removedStockIds.includes(id)))
    setSelectedInventoryId(prev => (prev || []).filter(id => !removedStockIds.includes(id)))
    setCurrentCheckId(prev => (prev || []).filter(id => !removedStockIds.includes(id)))
    setEachQtyItemIds((prev) => prev.filter((key) => remainingIds.includes(key)))
    if (remainingIds.length === 0) {
      setEachAll(false)
    }
    return currentList;
  }
  const autoPrint = async (itemsToPrint = selectedInventoryItems) => {
    const renderItems = isEachQtyTemplate
      ? expandItemsByQuantityForSelection(itemsToPrint, eachQtyItemIds)
      : itemsToPrint;

    return await exportPdf(selectedProfile.value, itemsToPrint, itemsToPrint, "printout", {
      getTemplateProfile: getCachedTemplateProfile,
      getStoreInfo: getCachedStoreInfo,
      sourceDataList: itemsToPrint,
      renderDataList: renderItems,
    });

  }
  const printAllFromPreview = async () => {
    if (!canPrint || isPrinting || printInProgressRef.current || templateType === "template_3") {
      return;
    }

    printInProgressRef.current = true;
    setIsPrinting(true);

    try {
      await autoPrint(printItems);
    } finally {
      printInProgressRef.current = false;
      setIsPrinting(false);
    }
  };
  useEffect(() => {
    return () => {
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
        }
    };
}, []);
  useEffect(() => {
    const isCheckedMode = PREVIEW_FILTER_BY_CHECKED_ITEMS && CHECKED_PREVIEW_TEMPLATES.has(templateType);
    const selectedItemIds = selectedInventoryItems.map(item => String(item.id));
    const previousSelectedItemIds = selectedPreviewItemIdsRef.current;
    const wasCheckedMode = checkedPreviewModeRef.current;

    if (isCheckedMode) {
      setCheckedItem((previousCheckedItems) => {
        const previousCheckedIds = new Set(previousCheckedItems);
        const listGotSmaller = selectedItemIds.length < previousSelectedItemIds.size;
        const nextCheckedItems = !wasCheckedMode || listGotSmaller
          ? selectedItemIds
          : selectedItemIds.filter(id => !previousSelectedItemIds.has(id) || previousCheckedIds.has(id));

        return nextCheckedItems.length === previousCheckedItems.length
          && nextCheckedItems.every((id, index) => id === previousCheckedItems[index])
          ? previousCheckedItems
          : nextCheckedItems;
      });
      checkedPreviewInitializedRef.current = true;
    } else {
      checkedPreviewInitializedRef.current = false;
    }

    checkedPreviewModeRef.current = isCheckedMode;
    selectedPreviewItemIdsRef.current = new Set(selectedItemIds);
  }, [selectedInventoryItems, templateType]);
  useEffect(() => {
    const selectedItemKeys = selectedInventoryItems.map(getPrintItemKey);

    if (!EACH_QTY_TEMPLATES.has(templateType)) {
      setEachAll(false);
      setEachQtyItemIds([]);
      return;
    }

    setEachQtyItemIds((previousKeys) => eachAll
      ? selectedItemKeys
      : previousKeys.filter((key) => selectedItemKeys.includes(key)));
  }, [eachAll, selectedInventoryItems, templateType]);
  useEffect(() => {
    if (!templateProfileList) {


      async function fetchData() {
        const listDataConfig = await _Api({ template_type: "barcode_printout_template" }, "api/v1/template-printout/list");
        let listProfileData = [];
        const { data } = await listDataConfig;
        data.map((v, k) => {
          if (k === 0) {
            listProfileData.push({

              label: "Please choose print layout",
              value: ""
            })
          }
          listProfileData.push({
            label: v.profile_name,
            value: v._id
          })
          return true;
        })


        setTemplateProfileList(listProfileData)

      }

      fetchData();
    }
    setCountSelectedInventoryItem(selectedInventoryItems.length)
    let debounceTimer = null;
    setCountSelectedInventoryItem(printItemCount)

    if (previewItemsForDisplay.length > 0 && startSearch === false && templateType !== "template_3") {

      // exportPdf's output only depends on the profile id + the resolved item
      // list, not on local state like templateType - so a cascade of renders
      // that leaves both unchanged (e.g. checkedItem auto-initializing to the
      // same ids) shouldn't trigger another full getByid/create/encode round trip.
      const previewSignature = `${selectedProfile?.value || ""}|${previewItemsForDisplay.map((item) => item?.id ?? item?._id ?? "").join(",")}`;

      if (previewSignature !== lastPreviewSignatureRef.current) {
        // Debounce too: several of these dependencies tend to change within the
        // same user action (item added, checkedItem initialized, profile applied),
        // so wait a beat and let only the final state generate a preview.
        debounceTimer = setTimeout(() => {
          lastPreviewSignatureRef.current = previewSignature;
          const previewRequestId = ++previewRequestRef.current;

          const genUri = async () => {

            const uridata = await exportPdf(selectedProfile.value ? selectedProfile.value : false, previewItemsForDisplay, previewItemsForDisplay, "uri", {
              getTemplateProfile: getCachedTemplateProfile,
              getStoreInfo: getCachedStoreInfo,
              sourceDataList: previewItems,
              renderDataList: previewItemsForDisplay,
            });
            if (previewRequestId !== previewRequestRef.current) return;
            setPaginationLinkList(uridata)

            if (uridata) {

              const base64String = uridata[0].replace('data:application/pdf;filename=generated.pdf;base64,', ''); // Your Base64 content (excluding "data:application/pdf;base64,")

              // Step 1: Decode the Base64 string
              const binaryString = atob(base64String);

              // Step 2: Convert binary string to Uint8Array
              const binaryData = new Uint8Array(binaryString.length);
              for (let i = 0; i < binaryString.length; i++) {
                binaryData[i] = binaryString.charCodeAt(i);
              }

              // Step 3: Create a Blob from the binary data
              const blob = new Blob([binaryData], { type: "application/pdf" });

              // Step 4: Create an Object URL
              const objectUrl = URL.createObjectURL(blob);

              // Step 5: Assign Object URL to the iframe
              setPdfUri(objectUrl)
            }

          }
          genUri()
        }, 150);
      }
    } else if (previewItemsForDisplay.length === 0 || templateType === "template_3") {
      lastPreviewSignatureRef.current = null;
      setPaginationLinkList(false)
      setPdfUri(false)
    }




    if (selectedProfile) {
      setDisabledItemSearch(false)
    }

    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }

    , [selectedInventoryItems, checkedItem, previewItems, previewItemsForDisplay, resultSearchList, startSearch, layoutProfileId, selectedProfile, currentSelectedId, setPaginationLinkList, setCountSelectedInventoryItem, templateProfileList, templateType, printItemCount])

  const addItemToSelectionList = async (item) => {
    setStartSearch(false)
    setResultSearchList(false)
    setSearchMenuBox(null)
    if (inventorySearchInputRef.current) {
      inventorySearchInputRef.current.value = "";
    }
    setCountSelectedInventoryItem(countSelectedInventoryItem + 1)
    // showSearchBoxResult.current.style("")

    setSelectedInventoryItems((prev) => {


      let obj = [...prev, item]

      return obj;
    })


    setCurrentSelectedId((prev) => {


      let obj = [...prev, item.stock_id]

      return obj;
    })


  }

  const selectLayoutProfile = async (e, syncSelectedProfile = true) => {
    if(!e?.value){
      return;
    }
    if (appliedProfileIdRef.current === e.value) {
      return;
    }
    appliedProfileIdRef.current = e.value;
    setDisabledItemSearch(false)

    setLayoutProfileId(e.value)
    if (syncSelectedProfile) {
      setSelectedProfileState((prev) => {
        if (prev?.value === e.value && prev?.label === e.label) {
          return prev;
        }
        return { "label": e.label, "value": e.value };
      })
    }
    try {
      const templateProfile = await getCachedTemplateProfile(e.value)
      const templateLayout = templateProfile?.data?.current_template_layout_selected;
      const templateValue = typeof templateLayout === "string" ? templateLayout : templateLayout?.value;
      if (templateValue) {
        setTemplateType(templateValue)
      }
      setTemplateProfileConfigData(getPrintConfig(templateProfile?.data))
    } catch (err) {
      console.log(err, 'err');
    }
  }

  const getLatestTemplateProfileConfig = async () => {
    const profileIdToFetch = layoutProfileId || selectedProfile?.value;
    if (!profileIdToFetch) {
      return templateProfileConfigData;
    }

    try {
      const latestProfile = await _Api({ _id: profileIdToFetch }, "api/v1/template-printout/getByid");
      const latestConfig = getPrintConfig(latestProfile?.data || {});
      setTemplateProfileConfigData(latestConfig);
      return latestConfig;
    } catch (error) {
      console.error("Unable to refresh barcode profile before printing", error);
      return templateProfileConfigData;
    }
  };

  useEffect(() => {
    if (selectedProfile?.value) {
      selectLayoutProfile(selectedProfile, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProfile?.value]);


  const genSinglePdfUri = (uridata) => {

    const base64String = uridata.replace('data:application/pdf;filename=generated.pdf;base64,', '');

    // Step 1: Decode the Base64 string
    const binaryString = atob(base64String);

    // Step 2: Convert binary string to Uint8Array
    const binaryData = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      binaryData[i] = binaryString.charCodeAt(i);
    }

    // Step 3: Create a Blob from the binary data
    const blob = new Blob([binaryData], { type: "application/pdf" });

    // Step 4: Create an Object URL
    const objectUrl = URL.createObjectURL(blob);

    // Step 5: Assign Object URL to the iframe
    setPdfUri(objectUrl)
  }


  const searchInventory = async (keyword) => {
    setStartSearch(true)
    const normalizedKeyword = typeof keyword === "string" ? keyword.trim() : "";
    const requestId = ++inventorySearchRequestRef.current;
    try {

      const postdata = {
        "item": [],
        "collection": [],
        "metal": [],
        "size": [],
        "stone": [],
        "productStatus": [],
        "location": [],
        "price": [],
        "search": normalizedKeyword,
        "limit": 100,
        "skip": 0,
      };
      if (normalizedKeyword) {
        if (normalizedKeyword.length < 2) {
          setStartSearch(false)
          setResultSearchList(false)
        } else {
          const res = await inventoryQueryClient.fetchQuery({
            queryKey: ["barcode-printout-inventory-search", postdata],
            queryFn: async () => {
              const cachedQueries = inventoryQueryClient.getQueriesData({
                queryKey: ["barcode-printout-inventory"],
              });
              const cachedRows = cachedQueries.flatMap(([, response]) => response?.data || []);
              const normalizedSearch = normalizedKeyword.toLowerCase();
              const cachedResult = cachedRows.filter((item) => {
                const searchableText = Object.values(item || {})
                  .flatMap((value) => value && typeof value === "object" ? Object.values(value) : [value])
                  .join(" ")
                  .toLowerCase();
                return searchableText.includes(normalizedSearch);
              });

              if (cachedResult.length > 0) {
                return { code: 200, data: cachedResult, total: cachedResult.length };
              }

              return _Api(postdata, `api/v1/Inventory/my/list/search`);
            },
          });
          if (requestId !== inventorySearchRequestRef.current) return;
          if (res?.data?.length > 0) {
            setResultSearchList(res.data)


          } else {
            setResultSearchList(false)


          }
        }


      } else {
        setResultSearchList(false)
        setStartSearch(false)
      }
    }
    catch (err) {
      if (requestId === inventorySearchRequestRef.current) {
        setResultSearchList(false)
        setStartSearch(false)
        console.log(err, 'err');
      }
    }
  }

  const handleInventorySearchInput = (e) => {
    const value = e.currentTarget.value;
    if (searchDebounceRef.current) {
      clearTimeout(searchDebounceRef.current);
    }
    searchDebounceRef.current = setTimeout(() => {
      searchInventory(value);
    }, 300);
  };

  useLayoutEffect(() => {
    if (!startSearch || !resultSearchList || !searchWrapRef.current) {
      setSearchMenuBox(null);
      return undefined;
    }
    const placeMenu = () => {
      const el = searchWrapRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      setSearchMenuBox({
        top: rect.bottom,
        left: rect.left,
        width: Math.max(rect.width, 280),
      });
    };
    placeMenu();
    window.addEventListener("resize", placeMenu);
    window.addEventListener("scroll", placeMenu, true);
    return () => {
      window.removeEventListener("resize", placeMenu);
      window.removeEventListener("scroll", placeMenu, true);
    };
  }, [startSearch, resultSearchList]);

  const closeInventorySearch = () => {
    setResultSearchList(false);
    setStartSearch(false);
    setSearchMenuBox(null);
  };

  const searchResultsToShow = Array.isArray(resultSearchList)
    ? resultSearchList.filter((item) => !currentSelectedId.includes(item.stock_id))
    : [];

  return (

    <>
      <div className="heading_breadcrumb_block printout_breadcrumb">


      </div>
      <div className="container-fluid preview_printout_page">



        <div className="row preview_printout_row">

          <div className="col-md-4">
            <div className="row profile_name_selection_block">
              <div className="row heading">
                <h3>1. Select Label</h3>
                <button className="add_barcode"
                  onClick={(e) => {
                    setPageStatus("add_profile_page")
                    setPageHeadingBreadCrumb({
                      heading: "Add Label Profile ",
                      breadCrumbName: "Add Label ",

                    })

                  }}

                >+ Add Label</button>
              </div>
              <div className="row selection">
                <Select
                  className="short mx-3 template_select profile_select"
                  options={templateProfileList}
                  onChange={selectLayoutProfile}
                  value={selectedProfile ? selectedProfile : { label: "", value: "" }}
                  menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 11000,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 11000,
                    }),
                    menuList: (base) => ({
                      ...base,
                      // scrollbarWidth: "none", 
                      // msOverflowStyle: "none", 
                    }),
                  }}
                // defaultValue={checkConfigData.current_template_layout_selected?checkConfigData.current_template_layout_selected:{label: "please select template name", value: ""}}
                />

              </div>
            </div>


            <div className="row inventory_selection_block">
              <div className={`heading ${checkedItem?.length ? "has-selection-actions" : ""}`}>
                <h3>2. Select Items </h3>

                <button className="add_from_inventory" onClick={() => {
                  setPageStatus("inventory_import_page")
                  setPageHeadingBreadCrumb({
                    heading: "Add Inventory ",
                    breadCrumbName: "Add Inventory",

                  })
                  window.location.href = "#add_inventory";

                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M21 10C21 8.34315 19.6568 7 18 7H10C8.3431 7 7 8.34315 7 10V18C7 19.6569 8.3431 21 10 21H18C19.6568 21 21 19.6569 21 18V10Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M14 14V11M14 14V17M14 14H11M14 14H17" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M17 3H6C4.3431 3 3 4.34315 3 6V17" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>  Inventory Add</button>

                <button className="import_stock_id_icon" onClick={() => {
                  setShowImportStockIdModal(!showImportStockIdModal)
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                    <path d="M12.8684 12.5081V16.4555C12.8684 16.745 12.6316 16.9818 12.3421 16.9818H1.02632C0.736842 16.9818 0.5 16.745 0.5 16.4555V1.19233C0.5 0.902858 0.736842 0.666016 1.02632 0.666016H7.8421L12.8684 5.42917V9.35023" stroke="#A4A4A4" />
                    <path d="M12.8682 5.64021H8.39448C8.10501 5.64021 7.86816 5.40337 7.86816 5.1139V0.929688" stroke="#A4A4A4" />
                    <path d="M2.86816 5.14062H6.28922" stroke="#A4A4A4" />
                    <path d="M2.86816 7.77148H11.0261" stroke="#A4A4A4" />
                    <path d="M2.86816 9.61328H11.0261" stroke="#A4A4A4" />
                    <path d="M2.86816 11.9824H9.18395" stroke="#A4A4A4" />
                    <path d="M2.86816 13.5605H7.34185" stroke="#A4A4A4" />
                    <path d="M7.60547 16.1916L8.63178 13.7179L13.9739 8.37582C14.0792 8.27056 14.2634 8.27056 14.3949 8.37582L15.4213 9.40214C15.5265 9.5074 15.5265 9.69161 15.4213 9.82319L10.0792 15.1653L7.60547 16.1916Z" stroke="#A4A4A4" stroke-linejoin="round" />
                    <path d="M13.3682 9.00781L14.7892 10.4289" stroke="#A4A4A4" />
                  </svg>
                </button>

                <button className="remove_selection_list" onClick={() => {
                  deleteListSelection(checkedItem)
                }} style={{ display: checkedItem?.length ? "flex" : "none" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M20.25 4.6875H16.3125V3.75C16.3125 3.20299 16.0952 2.67839 15.7084 2.29159C15.3216 1.9048 14.797 1.6875 14.25 1.6875H9.75C9.20299 1.6875 8.67839 1.9048 8.29159 2.29159C7.9048 2.67839 7.6875 3.20299 7.6875 3.75V4.6875H3.75C3.60082 4.6875 3.45774 4.74676 3.35225 4.85225C3.24676 4.95774 3.1875 5.10082 3.1875 5.25C3.1875 5.39918 3.24676 5.54226 3.35225 5.64775C3.45774 5.75324 3.60082 5.8125 3.75 5.8125H4.6875V19.5C4.6875 19.8481 4.82578 20.1819 5.07192 20.4281C5.31806 20.6742 5.6519 20.8125 6 20.8125H18C18.3481 20.8125 18.6819 20.6742 18.9281 20.4281C19.1742 20.1819 19.3125 19.8481 19.3125 19.5V5.8125H20.25C20.3992 5.8125 20.5423 5.75324 20.6477 5.64775C20.7532 5.54226 20.8125 5.39918 20.8125 5.25C20.8125 5.10082 20.7532 4.95774 20.6477 4.85225C20.5423 4.74676 20.3992 4.6875 20.25 4.6875ZM8.8125 3.75C8.8125 3.50136 8.91127 3.2629 9.08709 3.08709C9.2629 2.91127 9.50136 2.8125 9.75 2.8125H14.25C14.4986 2.8125 14.7371 2.91127 14.9129 3.08709C15.0887 3.2629 15.1875 3.50136 15.1875 3.75V4.6875H8.8125V3.75ZM18.1875 19.5C18.1875 19.5497 18.1677 19.5974 18.1326 19.6326C18.0974 19.6677 18.0497 19.6875 18 19.6875H6C5.95027 19.6875 5.90258 19.6677 5.86742 19.6326C5.83225 19.5974 5.8125 19.5497 5.8125 19.5V5.8125H18.1875V19.5ZM10.3125 9.75V15.75C10.3125 15.8992 10.2532 16.0423 10.1477 16.1477C10.0423 16.2532 9.89918 16.3125 9.75 16.3125C9.60082 16.3125 9.45774 16.2532 9.35225 16.1477C9.24676 16.0423 9.1875 15.8992 9.1875 15.75V9.75C9.1875 9.60082 9.24676 9.45774 9.35225 9.35225C9.45774 9.24676 9.60082 9.1875 9.75 9.1875C9.89918 9.1875 10.0423 9.24676 10.1477 9.35225C10.2532 9.45774 10.3125 9.60082 10.3125 9.75ZM14.8125 9.75V15.75C14.8125 15.8992 14.7532 16.0423 14.6477 16.1477C14.5423 16.2532 14.3992 16.3125 14.25 16.3125C14.1008 16.3125 13.9577 16.2532 13.8523 16.1477C13.7468 16.0423 13.6875 15.8992 13.6875 15.75V9.75C13.6875 9.60082 13.7468 9.45774 13.8523 9.35225C13.9577 9.24676 14.1008 9.1875 14.25 9.1875C14.3992 9.1875 14.5423 9.24676 14.6477 9.35225C14.7532 9.45774 14.8125 9.60082 14.8125 9.75Z" fill="#FF5757" />
                  </svg>
                </button>



              </div>
              <div className="row inventory_selection">



                <table className="inventory_list_table">
                  <thead>
                  {selectedInventoryItems.length > 0 ?
                    (

                      <tr className="item_check_heading">

                        <th>
                          <div className="inventory_item_check_controls">
                            <input
                              type="checkbox"
                              className="check_item_printing"
                              checked={selectedInventoryItems.length > 0 && checkedItemIds.length === selectedInventoryItems.length}
                              onChange={checkAllSelectedItem}
                              title="Select all items"
                            />
                            {isEachQtyTemplate ?
                              <label className="each_qty_all_control" title="Split all items by quantity">
                                <FiGitBranch aria-hidden="true" />
                                <input
                                  type="checkbox"
                                  className="each_qty_checkbox"
                                  checked={eachAll}
                                  onChange={toggleEachAll}
                                  aria-label="Split all items by quantity"
                                />
                              </label>
                              : null}
                          </div>
                        </th>
                        <th>#</th>
                        <th>
                          Item
                        </th>
                      </tr>
                    )

                    :
                    (

                      <tr>

                        <th>#</th>
                        <th>
                          Item
                        </th>
                      </tr>

                    )

                  }
                  </thead>
                  <tbody>


                  {selectedInventoryItems.length > 0 ?
                    (
                      <tr className={`row_search${startSearch && resultSearchList ? " is-open" : ""}`}>


                        <td>

                        </td>
                        <td></td>
                        <td>
                          <div
                            ref={searchWrapRef}
                            className={`item-search-wrap${startSearch && resultSearchList ? " is-open" : ""}`}
                          >
                          <input type="text"
                            className="item_search_print"
                            disabled={disabledItemSearch}
                            ref={inventorySearchInputRef}
                            onChange={handleInventorySearchInput}
                            placeholder="Stock_ID / SKU"
                          />
                          {resultSearchList === false && startSearch === true ?
                            <div class="not_found_search" style={{ display: resultSearchList === false && startSearch === true ? 'block' : 'none' }}>

                              <span class="not_found_text">
                                No result Found
                              </span>
                            </div>

                            : ""}
                          </div>
                        </td>
                      </tr>


                    )
                    :
                    (
                      <tr className={`row_search${startSearch && resultSearchList ? " is-open" : ""}`}>


                        {/* <td><input type="checkbox" className="check_item_printing" /></td> */}
                        <td></td>
                        <td>
                          <div
                            ref={searchWrapRef}
                            className={`item-search-wrap${startSearch && resultSearchList ? " is-open" : ""}`}
                          >
                          <input type="text"
                            className="item_search_print"
                            disabled={disabledItemSearch}
                            ref={inventorySearchInputRef}
                            onChange={handleInventorySearchInput}
                            placeholder="Stock_ID / SKU"
                          />
                          {resultSearchList === false && startSearch === true ?
                            <div class="not_found_search">

                              <span class="not_found_text">
                                No result Found
                              </span>
                            </div>

                            : ""}
                          </div>
                        </td>
                      </tr>


                    )
                  }





                  {selectedInventoryItems.length > 0 ?
                    selectedInventoryItems.map((v, k) => {
                      return (
                        <tr className="row-list" key={String(v.stock_id || v.id || k)} style={startSearch ? { pointerEvents: "none" } : undefined}>
                          <td>
                            <div className="inventory_item_check_controls">
                              <input type="checkbox" className="check_item_printing" value={v.id} checked={checkedItemIds.includes(String(v.id))} onChange={checkSelectedItem} title="Select item" />
                              {isEachQtyTemplate ?
                                <input
                                  type="checkbox"
                                  className="each_qty_checkbox"
                                  checked={eachQtyItemIds.includes(getPrintItemKey(v))}
                                  onChange={() => toggleEachQtyItem(v)}
                                  title="Split this item by quantity"
                                  aria-label={`Split ${v.SKU || v.stock_id || "item"} by quantity`}
                                />
                                : null}
                            </div>

                          </td>
                          <td>{k + 1}</td>
                          <td>
                            <span class="thumbnail_selection">
                              <img src={v.main_image} alt="p-image" />
                            </span>
                            <span class="detail_selection">
                              <h4>{v.name}</h4>
                              <span>{v.stock_id} {v.SKU}{v.location_name ? `\u00A0\u00A0${v.location_name}` : ""}</span>
                            </span>

                          </td>
                        </tr>

                      )

                    })
                    : ""}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan={12}><span className="total_count"><strong>Total {printItemCount} Item</strong></span></td>


                    </tr>
                  </tfoot>
                </table>
                <div className="action_print">
                  <button className="back_button" onClick={() => {
                    setPageStatus("list_profile_page")
                  }}>Back</button>
                  <button className="print_auto_button" disabled={!canPrint || isPrinting} onClick={async () => {
                    if (!canPrint || isPrinting || printInProgressRef.current) {
                      return;
                    }

                    printInProgressRef.current = true;
                    setIsPrinting(true);

                    try {
                      if (templateType !== "template_3" && templateType !== false) {
                        await autoPrint(printItems);
                      } else if (templateType === "template_3") {
                        const latestTemplate3Config = await getLatestTemplateProfileConfig();
                        const template3RenderItems = expandItemsByQuantityForSelection(
                          template3PrintItems,
                          eachQtyItemIds
                        );
                        await attachCustomPriceCodes(template3RenderItems, latestTemplate3Config, _Api);
                        const prn = await template3(
                          template3RenderItems,
                          template3RenderItems,
                          latestTemplate3Config
                        )
                        logBarcodePrint(template3PrintItems, selectedProfile?.label || "");

                        const iframe = iframeRef.current;



                        const onLoadHandler = async (prnv) => {
                          // Send a message to the iframe after it loads

                          // const addRfid  =  await _Api({
                          //   "rfid_content" :  prnv
                          // },"api/v1/template-printout/add-rfid-print-queue")
                          const addRfidQueue = await axios.post("https://print-prn-queue.gispos.com/api/add-print-queue", {
                            rfid_content: prnv,
                            user_token: btoa(localStorage.getItem("UserToken"))
                          })


                          if (addRfidQueue) {

                            iframe.contentWindow.postMessage(
                              {
                                action: 'printcustom',
                                payload: {
                                  prn_command: prnv,
                                  user_token: btoa(localStorage.getItem("UserToken"))
                                }

                              },
                              'https://print-prn.gispos.com/PrintZPL.php' // Specify the iframe's exact origin
                            );


                          }



                        };

                        // Attach the load event listener to ensure the iframe has fully loaded
                        // iframe.addEventListener('load', onLoadHandler);
                        // prn.map((v)=>{
                        //   console.log(v,'v pf qq')
                        //   onLoadHandler(v)

                        // })
                        await onLoadHandler(prn)
                      }
                    } finally {
                      printInProgressRef.current = false;
                      setIsPrinting(false);
                    }
                  }}>Print</button>

                </div>
              </div>
            </div>


          </div>

          <div className="col-md-8">


            {templateType !== false && templateType !== "template_3" ?

              <div className="print_preview_block">
                <div className="pagination_block">
                  Pages :
                  {paginationLinkList ?
                    paginationLinkList.map((v, k) => {
                      return (
                        <span className="paging_printpreview" onClick={() => {
                          genSinglePdfUri(v)
                        }}>{k + 1}</span>

                      )

                    })
                    : ""}
                </div>

                <div className="print_preview_toolbar">
                  <div className="print_preview_zoom_controls" aria-label="Preview zoom controls">
                    <button
                      type="button"
                      className="print_preview_zoom_button"
                      disabled={previewZoom <= PREVIEW_ZOOM_MIN}
                      onClick={zoomPreviewOut}
                      title="Zoom out"
                      aria-label="Zoom out"
                    >
                      <FiZoomOut aria-hidden="true" />
                    </button>
                    <span className="print_preview_zoom_value">{previewZoom}%</span>
                    <button
                      type="button"
                      className="print_preview_zoom_button"
                      disabled={previewZoom >= PREVIEW_ZOOM_MAX}
                      onClick={zoomPreviewIn}
                      title="Zoom in"
                      aria-label="Zoom in"
                    >
                      <FiZoomIn aria-hidden="true" />
                    </button>
                    <button
                      type="button"
                      className="print_preview_zoom_button"
                      disabled={previewZoom === 100}
                      onClick={resetPreviewZoom}
                      title="Reset zoom"
                      aria-label="Reset zoom"
                    >
                      <FiRefreshCw aria-hidden="true" />
                    </button>
                  </div>
                  <button
                    type="button"
                    className="print_preview_all_button"
                    disabled={!canPrint || isPrinting}
                    onClick={printAllFromPreview}
                    title="Print selected items"
                    aria-label="Print selected items"
                  >
                    <FiPrinter aria-hidden="true" />
                    <span>Print</span>
                  </button>
                </div>

                {pdfUri && previewItemsForDisplay.length > 0 ?
                  (
                    <div
                      className="print_preview_document_viewer"
                      ref={previewViewerRef}
                        onPointerDown={startPreviewPan}
                        onPointerMove={movePreviewPan}
                        onPointerUp={endPreviewPan}
                        onPointerCancel={endPreviewPan}
                    >
                      <Document
                        file={pdfUri}
                        onLoadSuccess={({ numPages }) => {
                          setPreviewPageCount(numPages);
                        }}
                        loading=""
                      >
                        {Array.from({ length: previewPageCount }, (_, pageIndex) => (
                          <Page
                            key={`preview-page-${pageIndex + 1}`}
                            pageNumber={pageIndex + 1}
                            scale={previewScale}
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                          />
                        ))}
                      </Document>
                    </div>
                  )
                  :

                  ""

                }
              </div>
              :
              <div className="print_preview_block">
                {templateType === "template_3" && countSelectedInventoryItem > 0 ?
                  (
                    <iframe title="d" id="rfid_print_frame" src="https://print-prn.gispos.com/PrintZPL.php?stock_id=101" ref={iframeRef}></iframe>
                  )
                  : ""
                }
              </div>
            }

          </div>

        </div>
      </div>

      {typeof document !== "undefined" && startSearch && resultSearchList && searchMenuBox
        ? createPortal(
            <ul
              className="selection_search_list selection_search_list--portal"
              style={{
                display: "block",
                position: "fixed",
                top: searchMenuBox.top,
                left: searchMenuBox.left,
                width: searchMenuBox.width,
                zIndex: 10050,
              }}
              onMouseDown={(e) => {
                e.preventDefault()
                e.stopPropagation()
              }}
            >
              <span
                className="close_selection_search_list"
                onMouseDown={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  closeInventorySearch()
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM6.04437 6.04437C6.28959 5.79916 6.68716 5.79916 6.93237 6.04437L9 8.11197L11.0677 6.04437C11.3129 5.79916 11.7104 5.79916 11.9556 6.04437C12.2008 6.28959 12.2008 6.68716 11.9556 6.93237L9.88794 9L11.9556 11.0677C12.2008 11.3129 12.2008 11.7104 11.9556 11.9556C11.7104 12.2008 11.3128 12.2008 11.0676 11.9556L9 9.88803L6.93237 11.9556C6.68715 12.2008 6.28959 12.2008 6.04437 11.9556C5.79916 11.7104 5.79916 11.3128 6.04437 11.0676L8.11197 9L6.04437 6.93237C5.79916 6.68715 5.79916 6.28959 6.04437 6.04437Z" fill="#A4A4A4" />
                </svg>
              </span>
              {searchResultsToShow.map((v, k) => (
                <li
                  key={String(v.stock_id || v.id || k)}
                  onMouseDown={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    addItemToSelectionList(v)
                  }}
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    addItemToSelectionList(v)
                  }}
                >
                  <span className="thumbnail_selection">
                    <img src={v.main_image} alt="p-image" />
                  </span>
                  <span className="detail">
                    <h4>{v.name}</h4>
                    <span>{v.stock_id} {v.SKU}</span>
                  </span>
                </li>
              ))}
            </ul>,
            document.body
          )
        : null}

    </>


  )
}

export default PrintPreview;
